/**
 * @file schemas/notification-templates.ts
 * @description 通知模板 Zod 校驗 schema（供前端與後端共用）。
 */
import { z } from 'zod';
/**
 * 建立通知模板請求 schema。
 * vars 為 JSONB 占位符列表，P0 使用 JSON textarea 輸入。
 */
export const createNotificationTemplateSchema = z.object({
    /** 模板唯一代碼（如 'audit-task-assigned'） */
    code: z.string().min(1).max(64),
    /** 模板名稱（人類可讀） */
    name: z.string().min(1).max(100),
    /** 站內通知標題 */
    inAppTitle: z.string().min(1).max(200),
    /** 站內通知內文 */
    inAppBody: z.string().min(1),
    /** Email 主旨（可選） */
    emailSubject: z.string().max(200).optional(),
    /** Email 內文（可選） */
    emailBody: z.string().optional(),
    /** 占位符列表 JSON（P0 接受任意 JSON） */
    vars: z.unknown().optional(),
    /** 是否啟用（預設 true） */
    isActive: z.boolean().optional(),
});
/**
 * 更新通知模板請求 schema（所有欄位可選）。
 */
export const updateNotificationTemplateSchema = createNotificationTemplateSchema.partial();
